import tw, { styled } from "twin.macro";
import "styled-components/macro";

export const ActiveDotIndicator = styled.span<{ isActive: boolean }>`
  ${tw`shrink-0 inline-block h-2 w-2 rounded-full mr-2`}
  ${({ isActive }) => (isActive ? tw`bg-success-default` : tw`bg-error-default`)}
`;
